(function() {
  'use strict';

  angular
    .module('scorm.scormCtrl')
    .service('scormModel', scormModel);

  scormModel.$inject = ['urlUtil'];

  function scormModel(urlUtil) {
    var self = this;

    self.scormHostUrl = null;
    self.playerUrl = null;
    self.contentUrl = null;
    self.trustedPlayerUrl = null;
    self.scormType = null;
    self.quiz = null;

    self.setPlayerUrl = function(url) {
      if (!url) return;

      self.playerUrl = url;

      var s = urlUtil.urlResolve(self.playerUrl);
      self.scormHostUrl = s.protocol + '://' + s.hostname;
    };

    self.setContentUrl = function(url) {
      if (!url) return;
      self.contentUrl = decodeURIComponent(url);
    };
  }
})();
